// contexts/UnreadContext.jsx
import { createContext, useContext, useState, useEffect } from "react"
import { pollUnreadCount } from "../services/messageService"
import { useAuth } from "./AuthProvider"

const UnreadContext = createContext(0)

export const UnreadProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0)
  const { user, loading } = useAuth()
  const participantId = user?.organizationId || user?.uid
  const isOrganization = Boolean(user?.organizationId)

  useEffect(() => {
    if (loading || !participantId) return
    const stop = pollUnreadCount(participantId, isOrganization, setUnreadCount)
    return () => stop()
  }, [loading, participantId])

  return <UnreadContext.Provider value={unreadCount}>{children}</UnreadContext.Provider>
}

export const useUnreadCount = () => useContext(UnreadContext)